import { useEffect } from 'react';
import Header from './Header';
import Hero from './Hero';
import Poles from './Poles';
import Pourquoi from './Pourquoi';
import PostbacForm from './PostbacForm';
import Contact from './Contact';
import Footer from './Footer';
import StickyCta from './StickyCta';
import { trackStandard } from '../../lib/pixel';
import { trackPostHog } from '../../lib/analytics';
import './postbac.css';

const PostbacPage = () => {
  useEffect(() => {
    trackStandard('ViewContent', {
      content_name: 'prepa-post-bac',
      content_category: 'landing',
    });
    trackPostHog('view_landing', { page: 'prepa-post-bac' });
  }, []);

  return (
    <div className="ppb-root">
      <Header />
      <Hero />
      <Poles />
      <Pourquoi />
      <PostbacForm />
      <Contact />
      <Footer />
      <StickyCta />
    </div>
  );
};

export default PostbacPage;
